export const state = {
  isLoading: false,
  isFileUpdate: false,
}

export type State = {
  isLoading: Boolean,
  isFileUpdate: Boolean
}
 